module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.136bea7e.ttf";